export default "__VITE_ASSET__Csu7SlB5__"